import React from "react";
import { withRouter } from "react-router";
import {
  PageHeader,
  Table,
  StatusTag,
  Spinner,
  Modal,
  Message,
  RepeatIcon,
  RightArrowIcon,
} from "dab-component-lib";
import axios from "axios";
import { ADD_ELEMENT, GETORDERS, REMOVE_ELEMENT } from "../../utils/constants";
import {
  GridContainerStyle,
  PageHeaderWrapperStyle,
  LoadingStyle,
  SpanStyle,
} from "../../utils/style-utils";
import { history as myHistory } from "../../Main";
import I18n from "../../I18n/I18n";
import { compose, graphql } from "react-apollo";
import {
  getText,
  productByCode,
  createNodeCartLineItem,
  createNodeCartLineItemWithSizes,
  currencyById,
  deleteNodeCartLineItem,
} from "../../queries";
import { currentUserCart } from "../../queries";
import { connect } from "react-redux";

let tableRows = [];
const tableColumns = [
  {
    alignment: "RIGHT",
    id: "totalPrice",
    header: I18n.t("orderTable.totalPrice"),
    type: "number",
    cell: (props) => (
      <span>
        {props.totalPrice
          ? props.totalPrice.length > 10
            ? `${props.totalPrice.slice(0, 10)}...€`
            : `${props.totalPrice}€`
          : I18n.t("orderTable.removed")}
      </span>
    ),
    sortable: true,
    accessor: "totalPrice",
  },
  {
    //alignment:'LEFT|CENTER|RIGHT',
    id: "dateOrder",
    header: I18n.t("orderTable.orderDate"),
    type: "number",
    cell: (props) => <span>{props.date ? props.date : "-"}</span>,
    sortable: true,
    relevant: true,
    accessor: "date",
  },
  {
    //alignment:'LEFT|CENTER|RIGHT',
    id: "orderCode",
    header: I18n.t("orderTable.orderCode"),
    accessor: "code",
    cell: (props) => <span>{props.code ? props.code : "-"}</span>,
    sortable: true,
    hidden: ["XS", "SM"],
  },
  {
    //alignment:'LEFT|CENTER|RIGHT',
    id: "customerName",
    header: I18n.t("orderTable.customerName"),
    accessor: "customer_name",
    cell: (props) => (
      <span>{props.customer_name ? props.customer_name : "-"}</span>
    ),
    sortable: true,
    hidden: ["XS", "SM"],
  },
  {
    //alignment:'LEFT|CENTER|RIGHT',
    id: "status",
    header: I18n.t("orderTable.statusOrder"),
    accessor: "status",
    sortable: true,
    cell: (props) => (
      <span>
        {props.status ? (
          <StatusTag
            lang={
              localStorage.getItem("language")
                ? localStorage.getItem("language")
                : "it"
            }
            status={props.status}
            onClick={() => goToOrderDetail(props.data)}
          />
        ) : (
          "-"
        )}
      </span>
    ),
  },
  {
    //alignment:'LEFT|CENTER|RIGHT',
    id: "repeat",
    accessor: "status",
    sortable: false,
    cell: (props) => (
      <span>
        {" "}
        {props.status ? (
          <SpanStyle onClick={() => props.openModal()}>
            {" "}
            {I18n.t("orderTable.repeatOrder")} <RepeatIcon />{" "}
          </SpanStyle>
        ) : (
          "-"
        )}{" "}
      </span>
    ),
  },
  {
    //alignment:'LEFT|CENTER|RIGHT',
    id: "details",
    accessor: "status",
    sortable: false,
    cell: (props) => (
      <span>
        {props.status ? (
          <SpanStyle onClick={() => goToOrderDetail(props.data)}>
            {" "}
            {I18n.t("productDetail.detail")} <RightArrowIcon />{" "}
          </SpanStyle>
        ) : (
          "-"
        )}
      </span>
    ),
  },
];

export const goToOrderDetail = (data) => {
  let id = data.calculated_data.order_code;
  myHistory.push({
    pathname: `/old-order-detail/${id}`,
    state: {
      data,
    },
  });
};

class UserOrders extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      offset: 0,
      rows: 10,
      currentPage: 1,
      loading: true,
      tableRows: [],
      count: 0,
      info: false,
      error: false,
      errorId: "",
      purchased: false,
      isEmptyCart: true,
      case: 1,
      products: [],
      notAvailable: [],
      availableProducts: [],
      reset: false,
    };
  }

  closeInfoCartModal = () => {
    this.setState({ info: false });
  };

  createNodeCartLineItem = async (targetIdProduct, quantity, size) => {
    const { createNodeCartLineItem, createNodeCartLineItemWithSizes } =
      this.props;
    let result = [];
    if (size) {
      result = await createNodeCartLineItemWithSizes({
        variables: {
          title: `user: ${localStorage.getItem(
            "currentUid"
          )} + product: ${targetIdProduct}`,
          targetIdProduct,
          quantity: quantity.toString(),
          size,
        },
      });
    } else {
      result = await createNodeCartLineItem({
        variables: {
          title: `user: ${localStorage.getItem(
            "currentUid"
          )} + product: ${targetIdProduct}`,
          targetIdProduct,
          quantity: quantity.toString(),
        },
      });
    }
    return result;
  };

  sendAvailableProduct = () => {
    this.setState({ loading: true });
    this.state.availableProducts.forEach(async (item) => {
      let nidObject = await this.createNodeCartLineItem(
        item.id,
        item.quantity,
        false
      );
      let nid = nidObject.data.createNodeCartLineItem.entity.nid;
      let currencyName = this.props.currencyById.nodeById.fieldCurrencyName;
      let uid = localStorage.getItem("currentUid");
      let res = {};
      if (
        !this.props.currentUserCart.error &&
        !this.props.currentUserCart.loading &&
        this.props.currentUserCart.currentusercartGraphql1View.results.length <
          1
      ) {
        res = await axios.get(
          `${ADD_ELEMENT}/create/${nid}/${currencyName}/${uid}`
        );
      } else {
        let cartId =
          this.props.currentUserCart.currentusercartGraphql1View.results[0].id;
        res = await axios.get(
          `${ADD_ELEMENT}/${cartId}/${nid}/${currencyName}/${uid}`
        );
      }
      if (res.data.status === 1) {
        this.props.currentUserCart.refetch();
        this.setState({ purchased: true });
      } else {
        this.setState({ error: true, errorId: item.id });
      }
    });
    this.props.history.push("/checkout");
  };

  addProductToCart = async (products, cart = false) => {
    let results;
    let avaibleProducts = [];
    let checkArray = [];
    let fin = false;
    for (let index = 0; index < products.length; index++) {
      results = await this.props.productByCode.refetch({
        code: products[index].item,
      });
      if (results.data.productcodeGraphql1View !== undefined) {
        let res = results.data.productcodeGraphql1View.results[0];

        // richiesta
        let availability =
          res && res.fieldAvailability ? res.fieldAvailability : 0;
        //quantità
        let max =
          res && res.fieldMaxShopQuantity ? res.fieldMaxShopQuantity : 0;

        let id = res && res.entityId ? res.entityId : null;
        // Quntità del prodotto da ricomprare
        let quantity = products[index].quantity;

        if (quantity >= availability || quantity >= max) {
          //if (index === 1) {
          checkArray.push(products[index]);
        } else {
          avaibleProducts.push({ ...products[index], id: id });
        }
      }

      if (index === products.length - 1) {
        fin = true;
      }
    }
    if (checkArray.length === 0) {
      avaibleProducts.forEach(async (item) => {
        let nidObject = await this.createNodeCartLineItem(
          item.id,
          item.quantity,
          false
        );
        let nid = nidObject.data.createNodeCartLineItem.entity.nid;
        let currencyName = this.props.currencyById.nodeById.fieldCurrencyName;
        let uid = localStorage.getItem("currentUid");
        let res = {};
        if (
          !this.props.currentUserCart.error &&
          !this.props.currentUserCart.loading &&
          this.props.currentUserCart.currentusercartGraphql1View.results
            .length < 1
        ) {
          res = await axios.get(
            `${ADD_ELEMENT}/create/${nid}/${currencyName}/${uid}`
          );
        } else {
          let cartId =
            this.props.currentUserCart.currentusercartGraphql1View.results[0]
              .id;
          res = await axios.get(
            `${ADD_ELEMENT}/${cartId}/${nid}/${currencyName}/${uid}`
          );
        }
        if (res.data.status === 1) {
          this.props.currentUserCart.refetch();
          this.setState({ purchased: true });
        } else {
          this.setState({ error: true, errorId: item.id });
        }
      });
    } else {
      return this.setState({
        loading: false,
        info: true,
        case: 4,
        notAvailable: checkArray,
        availableProducts: avaibleProducts,
      });
    }

    fin &&
      (cart
        ? this.props.history.push("/checkout", "loadin")
        : this.setState({ loading: false, info: true, case: 2 }));
  };

  openModal = (products) => {
    if (this.getEmptyCart() && this.state.case === 1) {
      this.setState({ loading: true, case: 1 });
      this.addProductToCart(products);
    } else {
      this.setState({
        loading: false,
        info: true,
        case: 3,
        products: products,
      });
    }
  };

  renderTableRow = (data) => {
    if (data !== false) {
      tableRows.push({
        totalPrice: data.remotedata.amount,
        date: data.calculated_data.date_of_order,
        code: data.calculated_data.order_code,
        customer_name: data.calculated_data.client_address.name,
        status: data.calculated_data.readable_status,
        openModal: () => {
          this.openModal(data.calculated_data.products);
        },
        data,
      });
    } else {
      tableRows.push({
        totalPrice: null,
        date: null,
        code: null,
        customer_name: null,
        status: null,
        openModal: () => {
          this.openModal();
        },
        data,
      });
    }
    this.setState({ tableRows });
  };

  componentWillMount() {
    let offset = this.state.offset;
    let rows = this.state.rows;
    let uid = localStorage.getItem("currentUid");
    axios
      .get(`${GETORDERS}/${offset}/${rows}/${uid}`)
      .then((response) => {
        this.setState({ count: response.data.total_order_resumes_count });
        tableRows = [];
        response.data.data.forEach((order) => {
          this.renderTableRow(order);
        });
        this.setState({ loading: false });
      })
      .catch((e) => console.log(e));
  }

  handleNavigateToPage = ({ currentPage, itemsPerPage }) => {
    this.setState({ loading: true });
    let offset = itemsPerPage * (currentPage - 1);
    let rows = itemsPerPage;
    let uid = localStorage.getItem("currentUid");
    axios
      .get(`${GETORDERS}/${offset}/${rows}/${uid}`)
      .then((response) => {
        tableRows = [];
        response.data.data.forEach((order) => {
          this.renderTableRow(order);
          this.setState({
            offset,
            currentPage,
            rows: itemsPerPage,
            loading: false,
          });
        });
      })
      .catch((e) => console.log(e));
  };

  getTitleModal = (caseState) => {
    if (caseState === 2 || caseState === 1) {
      return {
        0: I18n.t("modals.orderRepeatModal.emptyCart.title"),
        1: I18n.t("modals.orderRepeatModal.emptyCart.button1"),
        2: I18n.t("modals.orderRepeatModal.emptyCart.button2"),
      };
    } else if (caseState === 3) {
      return {
        0: I18n.t("modals.orderRepeatModal.notEmptyCart.title"),
        1: I18n.t("modals.orderRepeatModal.notEmptyCart.button1"),
        2: I18n.t("modals.orderRepeatModal.notEmptyCart.button2"),
        3: I18n.t("modals.orderRepeatModal.notEmptyCart.description"),
      };
    } else if (caseState === 4) {
      return {
        0: I18n.t("modals.orderRepeatModal.emptyCartCase4.title"),
        1: I18n.t("modals.orderRepeatModal.emptyCartCase4.button1"),
        2: I18n.t("modals.orderRepeatModal.emptyCartCase4.button2"),
        3: I18n.t("modals.orderRepeatModal.emptyCartCase4.description"),
      };
    }
  };

  resetCart = async (i = 0) => {
    const {
      currentUserCart: { loading, error, currentusercartGraphql1View, refetch },
    } = this.props;
    currentusercartGraphql1View.results.forEach((value) => {
      value.fieldLineItemsReference.forEach((item) => {
        let code = item.entity.fieldProductReference.entity.fieldCode;
        //cartQuantity.push(item.entity.fieldProductReference.entity.quantity)
        this.state.products.forEach((value) => {
          if (code === value.item) {
            value.quantity =
              value.quantity + item.entity.fieldProductReference.quantity;
          }
        });
      });
    });
    this.setState({ loading: true, info: false });
    let uid = localStorage.getItem("currentUid");
    if (!loading && !error && currentusercartGraphql1View.results.length > 0) {
      let cart_id = currentusercartGraphql1View.results[0].id;
      currentusercartGraphql1View.results[0].fieldLineItemsReference.forEach(
        async (item) => {
          let id = item.targetId;
          await axios.get(`${REMOVE_ELEMENT}/${cart_id}/${id}/${uid}`);
          i++;
          await this.resetCart();
        }
      );
    }
    await refetch();
    i--;
  };

  goToCart = () => {
    this.props.history.push("/checkout");
  };

  getEmptyCart = () => {
    let emptyCart =
      this.props.currentUserCart.currentusercartGraphql1View !== undefined &&
      this.props.currentUserCart.currentusercartGraphql1View.results.length > 0 &&
      this.props.currentUserCart.currentusercartGraphql1View.results[0]

        .fieldLineItemsReference.length > 0
        ? false
        : true;
    return emptyCart;
  };

  render() {
    const { loading, currentPage } = this.state;
    const { getText } = this.props;

    if (
      this.state.reset === true &&
      this.props.currentUserCart.currentusercartGraphql1View !== undefined &&
      this.props.currentUserCart.currentusercartGraphql1View.results[0]
        .fieldLineItemsReference.length === 0
    ) {
      this.setState({ reset: false }, () =>
        this.addProductToCart(this.state.products, true)
      );
    }

    if (getText.loading) {
      return (
        <LoadingStyle>
          <Spinner size={150} />
        </LoadingStyle>
      );
    }
    if (getText.error) {
      return (
        <div>
          <h3>{I18n.t("errors.generalError")}</h3>
        </div>
      );
    }
    return (
      <GridContainerStyle>
        <PageHeaderWrapperStyle bigger>
          <PageHeader
            title={
              getText.translationMetadataGraphql1View.results.length > 0 &&
              getText.translationMetadataGraphql1View.results[0].fieldMainText
            }
            description={
              getText.translationMetadataGraphql1View.results.length > 0 &&
              getText.translationMetadataGraphql1View.results[0].fieldSubText
            }
          />
        </PageHeaderWrapperStyle>
        <Modal
          open={this.state.info}
          handleClose={() => this.closeInfoCartModal()}
        >
          <div>
            <Message
              full={true}
              action={{
                label: this.getTitleModal(this.state.case)[2],
                onClick:
                  this.state.case === 2
                    ? () => this.goToCart()
                    : this.state.case === 4
                    ? () => this.sendAvailableProduct()
                    : () =>
                        this.setState({ reset: true }, () => this.resetCart()),
              }}
              actionSecondary={{
                label: this.getTitleModal(this.state.case)[1],
                onClick:
                  this.state.case === 2
                    ? () => this.closeInfoCartModal()
                    : () => this.closeInfoCartModal(),
                outline: true,
              }}
              description={
                !this.getEmptyCart()
                  ? this.getTitleModal(this.state.case)[3]
                  : this.state.case === 4
                  ? this.getTitleModal(this.state.case)[3]
                  : ""
              }
              title={this.getTitleModal(this.state.case)[0]}
            >
              {this.state.case === 4 &&
                this.state.notAvailable.length > 0 &&
                this.state.notAvailable.map((item) => {
                  return (
                    <p>
                      {" "}
                      <strong>
                        {" "}
                        - {item.item} - {item.item_description}{" "}
                      </strong>{" "}
                    </p>
                  );
                })}
            </Message>
          </div>
        </Modal>
        <Table
          columns={tableColumns}
          component={Table}
          loading={loading}
          pagination={{
            itemsTotalCount: this.state.count,
            currentPage,
            handleNavigateToPage: this.handleNavigateToPage,
          }}
          rows={tableRows}
        />
      </GridContainerStyle>
    );
  }
}

export default connect()(
  compose(
    graphql(getText, {
      name: "getText",
      options: (props) => ({
        variables: {
          machineName: "user_orders",
          lang: localStorage.getItem("language")
            ? localStorage.getItem("language")
            : "it",
        },
      }),
    }),
    graphql(productByCode, {
      name: "productByCode",
      options: (code) => ({
        variables: {
          code: "",
        },
      }),
    }),
    graphql(createNodeCartLineItem, {
      name: "createNodeCartLineItem",
    }),
    graphql(createNodeCartLineItemWithSizes, {
      name: "createNodeCartLineItemWithSizes",
    }),
    graphql(deleteNodeCartLineItem, {
      name: "deleteNodeCartLineItem",
    }),
    graphql(currentUserCart, {
      name: "currentUserCart",
      options: (props) => ({
        variables: {
          id: localStorage.getItem("currentUid"),
          lang: localStorage.getItem("language")
            ? localStorage.getItem("language")
            : "it",
        },
      }),
    }),
    graphql(currencyById, {
      name: "currencyById",
      options: (props) => ({
        variables: {
          id: localStorage.getItem("currency")
            ? localStorage.getItem("currency")
            : localStorage.getItem("defaultCurrency"),
        },
      }),
    })
  )(withRouter(UserOrders))
);



// WEBPACK FOOTER //
// ./src/components/userOrders/index.js